import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import Main, {
  Setting,
  PrescriptionDashboard,
  Appointment,
  ManagementDashboard,
  VisitReport,
  TicketReport,
  PaymentsReport,
  InsuranceSharePaymentsReport,
  Login,
  TicketRequest,
  Timesheet,
  Reports,
  Chat,
  Support,
} from './components'
import { Patient } from './share/Elements'
import './extensions'
import axios from 'axios'
import Downloads from './components/Downloads/Downloads'
import AppNoAuth from './AppNoAuth'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <App>
        <Main />
      </App>
    ),
  },
  {
    path: '/login',
    element: (
      <App>
        <Login />
      </App>
    ),
  },
  {
    path: '/user',
    element: (
      <App>
        <></>
      </App>
    ),
  },
  {
    path: '/prescription/:componenet',
    element: (
      <App>
        <PrescriptionDashboard />
      </App>
    ),
  },
  {
    path: '/setting',
    element: (
      <App>
        <Setting />
      </App>
    ),
  },
  {
    path: '/Patient',
    element: (
      <App>
        <Patient />
      </App>
    ),
  },
  {
    path: '/Support',
    element: (
      <App>
        <Support />
      </App>
    )
  },
  {
    path: '/Appointment',
    element: (
      <App>
        <Appointment />
      </App>
    ),
  },
  {
    path: '/ManagementDashboard',
    element: (
      <App>
        <ManagementDashboard />
      </App>
    ),
  },
  {
    path: '/ManagementDashboard/Visit',
    element: (
      <App>
        <VisitReport />
      </App>
    ),
  },
  {
    path: '/ManagementDashboard/Ticket',
    element: (
      <App>
        <TicketReport />
      </App>
    ),
  },
  {
    path: '/ManagementDashboard/Payments',
    element: (
      <App>
        <PaymentsReport />
      </App>
    ),
  },
  {
    path: '/ManagementDashboard/InsuranceSharePayments',
    element: (
      <App>
        <InsuranceSharePaymentsReport />
      </App>
    ),
  },
  // {
  //   path: '/FinancialReport',
  //   element: (
  //     <App>
  //       <FinancialReport />
  //     </App>
  //   ),
  // },
  {
    path: '/TicketRequest',
    element: (
      <App>
        <TicketRequest />
      </App>
    ),
  },
  {
    path: '/Chat',
    element: (
      <AppNoAuth>
        <Chat />
      </AppNoAuth>
    ),
  },
  {
    path: '/TimeSheet',
    element: (
      <App>
        <Timesheet />
      </App>
    ),
  },
  {
    path: '/Reports',
    element: (
      <App>
        <Reports />
      </App>
    ),
  },
  {
    path: '/Downloads',
    element: (
      <App>
        <Downloads />
      </App>
    ),
  },
], {
  basename: window.env['App_BaseUrl']
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
axios.defaults.withCredentials = true

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./sw.js')
    .then(registration => {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(error => {
      console.error('Service Worker registration failed:', error);
    });
}

root.render(
  <>
    <RouterProvider router={router} />
  </>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
